<script>
import StatsDataService from "@/services/StatsDataService";

export default {
  name: "ChartUsersConnections",
  data() {
    return {
      series:[],
      chartOptions: {
        chart: {
          id: 'users-connections',
          type: 'area',
          stacked: true,
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        tooltip: {
          shared: true,
          intersect: false
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,

            datetimeUTC: false,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        fill: {
          type: 'gradient',
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          }
        },
        noData: {
          text: 'Loading...'
        }
      },
      filtersDates: {
        selected: 'T',
        options: [
          {value:'T', text:'T.'},
          {value:'Y', text:'Y.'},
          {value:'1W', text:'1W'},
        ]
      }
    }
  },
  methods: {
    handleDateChange() {
      this.loadData();
    },

    loadData() {
      const params = {date: this.filtersDates.selected};
      StatsDataService.getUsersConnections(params)
          .then(response => {
            const data = response.data;
            this.$refs.usersConnectionsChart.updateSeries([{
              name: this.$t("male"),
              data: data.male,
            },{
              name: this.$t("female"),
              data: data.female,
            }]);
          })
          .catch(error => {
            window.console.error("StatsDataService.getUsersConnections failed...", error);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <div class="card-body" id="cardChartConnections">
      <h5 class="card-title">Connections Real-time History</h5>
      <b-form-radio-group
          v-model="filtersDates.selected"
          :options="filtersDates.options"
          button-variant="outline-secondary"
          size="sm"
          buttons
          class="mt-1 mb-2"
          @change="handleDateChange"
      ></b-form-radio-group>
    <apexchart
        ref="usersConnectionsChart"
        type="area"
        dir="ltr"
        height="350"
        :series="series"
        :options="chartOptions"
    ></apexchart>
  </div>
</template>

<style>
#cardChartConnections .btn input[type=radio] {
  position: absolute;
  clip: rect(0,0,0,0);
  pointer-events: none;
}

#cardChartConnections .btn {
  margin-top: -8px;
  margin-bottom: 0 !important;
}
</style>
